import { FilterOptionOption } from 'chakra-react-select';
import { MemberOption } from './types';

export const getLoadingMessage = () => 'Loading users...';
export const getNoOptionsMessage = () => 'No users found';

export const matchPastedEmails = (
  pastedText: string,
  members: MemberOption[],
  currentSelection: MemberOption[],
): MemberOption[] | null => {
  const parts = pastedText.split(/[,;\s]+/).filter(Boolean);
  const lowered = new Set(parts.map((p) => p.toLowerCase()));
  const matched = members.filter((m) => lowered.has(m.email.toLowerCase()));

  if (!matched.length) return null;

  return Array.from(
    new Map(
      [...currentSelection, ...matched].map((m) => [m.email.toLowerCase(), m]),
    ).values(),
  );
};

export const filterOptions = (
  candidate: FilterOptionOption<MemberOption>,
  input: string,
): boolean => {
  const search = input?.toLowerCase();
  const { email, label } = candidate.data;

  if (!search) return true; // If no search input, show all options
  if (!email || !label) return false; // If email or label is missing, do not show the option
  return (
    label.toLowerCase().includes(search) || email.toLowerCase().includes(search)
  );
};
